import { schema } from 'normalizr'

import CustomerNotification from '@/models/customer-notification'

const customerNotificationSchema = new schema.Entity('customerNotifications')

interface NotificationBaseResponse {
  entities: {
    customerNotifications: { [id: number]: CustomerNotification }
  }
  result: number | number[]
}

export interface NotificationResponse extends NotificationBaseResponse {
  result: number
}

export interface NotificationsResponse extends NotificationBaseResponse {
  result: number[]
}

export default customerNotificationSchema
export const customerNotificationsSchema = new schema.Array(
  customerNotificationSchema,
)
